export const queryKeys = {
  NEWS_POST_SCHEDULE: 'NEWS_POST_SCHEDULE'
};
